import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { createModuleTranslator, type ModuleTranslateFn } from './moduleT';

export function useModuleTranslation(i18nKey?: string): {
  i18nKey: string | undefined;
  mt: ModuleTranslateFn;
  enabled: boolean;
} {
  const ns = i18nKey ?? 'common';
  const { t } = useTranslation(ns);

  const mt = useCallback<ModuleTranslateFn>(
    (path, fallback) => {
      if (!i18nKey) return fallback;
      return createModuleTranslator(t)(path, fallback);
    },
    [i18nKey, t],
  );

  return { i18nKey, mt, enabled: Boolean(i18nKey) };
}
